import React, { useState } from 'react';
import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <button onClick={scrollToTop}
            style={{
                backgroundColor: '#ffffff00',
                borderRadius: 10,
                zIndex: 10,
                bottom: 10,
                right: 10,
                position: "fixed",
                flexDirection: "column",
                display: visible ? 'inline' : 'none',
            }}>
            <FontAwesomeIcon icon={faArrowCircleUp} style={{
                color: 'white',
                width: 35,
                height: 35
            }} />
        </button>
    )

}

export default ScrollButton;